import MataPelajaran from '../../../views/Kurikulum/MataPelajaran/MataPelajaran.view';
import { connect } from 'react-redux';

function mapStateToProps(state) {
    return {
        user: state.user || {},
      };
  }

export default connect(mapStateToProps, null) (MataPelajaran);